import { render, staticRenderFns } from "./UserNavigation.vue?vue&type=template&id=179fd5a1"
import script from "./UserNavigation.vue?vue&type=script&lang=js"
export * from "./UserNavigation.vue?vue&type=script&lang=js"
import style0 from "./UserNavigation.vue?vue&type=style&index=0&id=179fd5a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports